export enum FieldType {
  FreeText = "FreeText",
  Numeric = "Numeric",
  Date = "Date",
  DropdownSingle = "DropdownSingle",
  DropdownMultiple = "DropdownMultiple"
}
